module.exports = "<p>\r\n  Bienvenid@ al panel de administración de {{ mainConfig.cmsName }}\r\n</p>\r\n<button\r\n    mat-raised-button\r\n    color=\"primary\"\r\n    (click)=\"clearCache()\"\r\n  >\r\n    <mat-icon>cached</mat-icon>Borrar Caché\r\n</button>"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/dashboard/dashboard-screen/dashboard-screen.component.html
// module id = ./libs/atenea-cms-brand/src/dashboard/dashboard-screen/dashboard-screen.component.html
// module chunks = main